export type ColorSchema = { text: string; container: string };

export enum VerificationPreferenceFormFields {
  verificationPreference = 'verificationPreference',
}

export enum PrivacySettingsRequirementOptions {
  allowAll = 'Verifications will be approved automatically',
  requireWithMyApprove = 'Verification requests will require your approval from your Clear Verify account',
}

export type VerificationPreferenceFormValues = {
  [VerificationPreferenceFormFields.verificationPreference]: PrivacySettingsRequirementOptions;
};
